// import { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Typography, Grid } from "@mui/material";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import httpclient from "../../../../Utils";
// import { createFilterHandler } from "../../../../Utils/FilterUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { useBranch } from "../../../../Hooks/useBranch";
// import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

// import Filter from "./Filter";
// import { ORDER_STATUSES } from "./constants";
// import OrderTabs from "./OrderTabs";

// import { getColumns } from "./columns";
// import OrderDetailsModal from "./OrderDetailsModal";
// import OrderCounts from "./OrderCounts";

// const INITIAL_FILTER_STATE = {
//   invoice_number: "",
//   jobNo: "",
//   customer: "",
//   status: "",
//    invoiceDateStart: null,
//   invoiceDateEnd: null,
//   // orderDateStart: "",
//   // orderDateEnd: "",
//   deliveryDateStart: "",
//   deliveryDateEnd: "",
//   bay: "",
//   driver_id: "",
// };

// const fieldMappings = {
//   jobNo: ["job_id", "$eq"],
//   customer: ["customer", "$eq"],
//   status: ["delivery_status", "$eq"],
//   bay: ["bin_bay", "$contains"],
//   driver_id: ["driver_id", "$eq"],
//   invoice_number: ["invoice_number", "$eq"],
// };

// const rangeFields = {
//   orderDate: {
//     apiField: "order_date",
//     minField: "orderDateStart",
//     maxField: "orderDateEnd",
//   },
//   deliveryDate: {
//     apiField: "delivery_date",
//     minField: "deliveryDateStart",
//     maxField: "deliveryDateEnd",
//   },
//    invoiceDate: {  
//     apiField: "invoice_date",
//     minField: "invoiceDateStart",
//     maxField: "invoiceDateEnd",
//   },
// };

// const valueTransformers = {
//   // Add any value transformations if needed
// };

// export default function Orders() {
//   const location = useLocation();
//   const [orders, setOrders] = useState([]);
//   const [orderStatuses, setOrderStatuses] = useState([]);
//   const [drivers, setDrivers] = useState([]);
//   const [activeTab, setActiveTab] = useState("all");
//   const [filterOpen, setFilterOpen] = useState(false);
//   const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
//   const [submittedData, setSubmittedData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [rowCount, setRowCount] = useState(0);
//   const [sortModel, setSortModel] = useState([]);
//   const [refreshList, setRefreshList] = useState(false);
//   const [orderDetailsOpen, setOrderDetailsOpen] = useState(false);
//   const [selectedJobId, setSelectedJobId] = useState(null);

//   const { currentBranch } = useBranch();
//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();

//   // Handle modal re-opening from navigation state (when returning from TrackOrder)
//   useEffect(() => {
//     if (location.state?.reopenModal && location.state?.jobId) {
//       setSelectedJobId(location.state.jobId);
//       setOrderDetailsOpen(true);

//       // Clear the state to prevent re-opening on refresh
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state]);

//   const fetchOrders = async () => {
//     setLoading(true);

//     const currentTab = ORDER_STATUSES.find((tab) => tab.value === activeTab);
//     const endpoint = currentTab?.endpoint || "delivery/orders/all";

//     const apiUrl = buildApiQuery(endpoint, {
//       page: paginationModel.page + 1,
//       pageSize: paginationModel.pageSize,
//       filters: submittedData,
//       sortModel,
//       fieldMappings,
//       rangeFields,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;

//       if (data.status === 200) {
//         // Add unique id for DataGrid (using job_id as the unique identifier)
//         const ordersWithId = data.data.map((order, index) => ({
//           ...order,
//           id: order.job_id || index,
//         }));
//         setOrders(ordersWithId);
//         setRowCount(data.meta?.total || data.count || 0);

//         // Store order statuses for filter dropdown
//         if (data.orderStatus && data.orderStatus.length > 0) {
//           setOrderStatuses(data.orderStatus);
//         }

//         // Store drivers for filter dropdown
//         if (data.drivers && data.drivers.length > 0) {
//           setDrivers(data.drivers);
//         }

//         setRefreshList(false);
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, [
//     activeTab,
//     refreshList,
//     currentBranch,
//     paginationModel.page,
//     paginationModel.pageSize,
//     sortModel,
//     submittedData,
//   ]);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleChangeFilter = (field) => (event, value) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [field]: value || (event && event.target.value) || "",
//     }));
//   };

//   const currentTabConfig = ORDER_STATUSES.find(
//     (tab) => tab.value === activeTab
//   );
//   const handleFilter = createFilterHandler({
//     setLoading,
//     setSubmittedData,
//     setResults: (data) => {
//       // Add unique id for DataGrid (using job_id as the unique identifier)
//       const ordersWithId = data.map((order, index) => ({
//         ...order,
//         id: order.job_id || index,
//       }));
//       setOrders(ordersWithId);
//     },
//     showNotification,
//     handleApiError,
//     httpClient: httpclient,
//     endpoint: currentTabConfig?.endpoint || "delivery/orders/all",
//     fieldMappings,
//     rangeFields,
//     valueTransformers,
//     refresh,
//   });

//   const onFilterClick = () => {
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     handleFilter(filterData);
//   };

//   const handleRemove = async (field) => {
//     const newFilterData = { ...filterData };
//     const newSubmittedData = { ...submittedData };

//     newFilterData[field] = "";
//     delete newSubmittedData[field];

//     setFilterData(newFilterData);
//     setSubmittedData(newSubmittedData);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));

//     // Manually fetch data after removing filter to ensure proper id assignment
//     setLoading(true);
//     const currentTab = ORDER_STATUSES.find((tab) => tab.value === activeTab);
//     const endpoint = currentTab?.endpoint || "delivery/orders/all";

//     const apiUrl = buildApiQuery(endpoint, {
//       page: 1,
//       pageSize: paginationModel.pageSize,
//       filters: newSubmittedData,
//       sortModel,
//       fieldMappings,
//       rangeFields,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;

//       if (data.status === 200) {
//         const ordersWithId = data.data.map((order, index) => ({
//           ...order,
//           id: order.job_id || index,
//         }));
//         setOrders(ordersWithId);
//         setRowCount(data.meta?.total || data.count || 0);

//         if (data.orderStatus && data.orderStatus.length > 0) {
//           setOrderStatuses(data.orderStatus);
//         }

//         if (data.drivers && data.drivers.length > 0) {
//           setDrivers(data.drivers);
//         }
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClearFilters = () => {
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleRowClick = (params) => {
//     setSelectedJobId(params.row.job_id);
//     setOrderDetailsOpen(true);
//   };

//   const handleCloseOrderDetails = () => {
//     setOrderDetailsOpen(false);
//     setSelectedJobId(null);
//   };

//   const columns = getColumns();

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <OrderCounts onCardClick={handleTabChange} activeTab={activeTab} />
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12}>
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
//               Orders
//             </Typography>
//             <OrderTabs
//               activeTab={activeTab}
//               onTabChange={handleTabChange}
//               filterOpen={filterOpen}
//               filterIcon={filterOpen ? FilterBtnUp : FilterBtn}
//               onFilterClick={() => setFilterOpen(!filterOpen)}
//             />
//           </Grid>
//           <Filter
//             filterOpen={filterOpen}
//             filterData={filterData}
//             handleChangeFilter={handleChangeFilter}
//             handleFilter={onFilterClick}
//             handleClearFilters={handleClearFilters}
//             handleRemove={handleRemove}
//             submittedData={submittedData}
//             orderStatuses={orderStatuses}
//             drivers={drivers}
//           />
//         </Grid>

//         <DataGrid
//           rows={orders || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           onRowClick={handleRowClick}
//           initialState={{
//             pagination: { paginationModel: { pageSize: 20 } },
//           }}
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           disableColumnMenu
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//             "& .MuiDataGrid-columnHeader": {
//               backgroundColor: "#d6d6d6ff !important",
//               color: "#fff !important",
//             },
//             "& .MuiDataGrid-columnHeaderTitle": {
//               fontWeight: 700,
//               color: "#242424ff !important",
//             },
//             "& .MuiDataGrid-columnSeparator": {
//               color: "rgba(177, 177, 177, 1)",
//             },
//             "& .MuiDataGrid-row": {
//               cursor: "pointer",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel}
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />
//       </Box>

//       {/* Order Details Modal */}
//       {orderDetailsOpen && (
//         <OrderDetailsModal
//           open={orderDetailsOpen}
//           onClose={handleCloseOrderDetails}
//           jobId={selectedJobId}
//         />
//       )}
//     </Box>
//   );
// }



// import { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Typography, Grid } from "@mui/material";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import httpclient from "../../../../Utils";
// import { createFilterHandler } from "../../../../Utils/FilterUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { useBranch } from "../../../../Hooks/useBranch";
// import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

// import Filter from "./Filter";
// import { ORDER_STATUSES } from "./constants";
// // import OrderTabs from "./OrderTabs";

// import { getColumns } from "./columns";
// import OrderDetailsModal from "./OrderDetailsModal";
// import OrderCounts from "./OrderCounts";

// const INITIAL_FILTER_STATE = {
//   invoice_number: "",
//   jobNo: "",
//   customer: "",
//   status: "",
//    invoiceDateStart: null,
//   invoiceDateEnd: null,
//   // orderDateStart: "",
//   // orderDateEnd: "",
//   deliveryDateStart: "",
//   deliveryDateEnd: "",
//   bay: "",
//   driver_id: "",
// };

// const fieldMappings = {
//   jobNo: ["job_id", "$eq"],
//   customer: ["customer", "$eq"],
//   status: ["delivery_status", "$eq"],
//   bay: ["bin_bay", "$contains"],
//   driver_id: ["driver_id", "$eq"],
//   invoice_number: ["invoice_number", "$eq"],
// };

// const rangeFields = {
//   orderDate: {
//     apiField: "order_date",
//     minField: "orderDateStart",
//     maxField: "orderDateEnd",
//   },
//   deliveryDate: {
//     apiField: "delivery_date",
//     minField: "deliveryDateStart",
//     maxField: "deliveryDateEnd",
//   },
//    invoiceDate: {  
//     apiField: "invoice_date",
//     minField: "invoiceDateStart",
//     maxField: "invoiceDateEnd",
//   },
// };

// const valueTransformers = {
//   // Add any value transformations if needed
// };

// const resolveOrdersEndpoint = (tabValue, isToday) => {
//   const currentTab = ORDER_STATUSES.find((tab) => tab.value === tabValue);
//   const baseEndpoint = currentTab?.endpoint || "delivery/orders/all";

//   if (!isToday) {
//     return baseEndpoint;
//   }

//   const normalized = baseEndpoint.replace(/^\/?delivery\/orders\/?/, "");
//   return normalized
//     ? `/delivery/today-orders/${normalized}`
//     : "/delivery/today-orders/all";
// };

// export default function Orders() {
//   const location = useLocation();
//   const isToday = location.pathname === "/delivery/orders/today";
  
//   // Developer mode: Read query parameters to show hidden cards
//   const searchParams = new URLSearchParams(location.search);
//   const showAllCard = searchParams.get("all") === "true";
//   const showWaitingCard = searchParams.get("waiting") === "true";
  
//   const [orders, setOrders] = useState([]);
//   const [orderStatuses, setOrderStatuses] = useState([]);
//   const [drivers, setDrivers] = useState([]);
//   const [activeTab, setActiveTab] = useState("waitingQueue");
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);
//   const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
//   const [submittedData, setSubmittedData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [rowCount, setRowCount] = useState(0);
//   const [sortModel, setSortModel] = useState([]);
//   const [refreshList, setRefreshList] = useState(false);
//   const [orderDetailsOpen, setOrderDetailsOpen] = useState(false);
//   const [selectedJobId, setSelectedJobId] = useState(null);

//   const { currentBranch } = useBranch();
//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();

//   // Reset all state when navigating between All Jobs and Today Jobs
//   useEffect(() => {
//     setOrders([]);
//     setActiveTab("waitingQueue");
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel({ page: 0, pageSize: 20 });
//     setSortModel([]);
//     setFilterAnchorEl(null);
//     setRefreshList(true);
//   }, [location.pathname]);

//   // Handle modal re-opening from navigation state (when returning from TrackOrder)
//   useEffect(() => {
//     if (location.state?.reopenModal && location.state?.jobId) {
//       setSelectedJobId(location.state.jobId);
//       setOrderDetailsOpen(true);

//       // Clear the state to prevent re-opening on refresh
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state]);

//   const fetchOrders = async () => {
//     setLoading(true);

//     const endpoint = resolveOrdersEndpoint(activeTab, isToday);

//     const apiUrl = buildApiQuery(endpoint, {
//       page: paginationModel.page + 1,
//       pageSize: paginationModel.pageSize,
//       filters: submittedData,
//       sortModel,
//       fieldMappings,
//       rangeFields,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;

//       if (data.status === 200) {
//         // Add unique id for DataGrid (using job_id as the unique identifier)
//         const ordersWithId = data.data.map((order, index) => ({
//           ...order,
//           id: order.job_id || index,
//         }));
//         setOrders(ordersWithId);
//         setRowCount(data.meta?.total || data.count || 0);

//         // Store order statuses for filter dropdown
//         if (data.orderStatus && data.orderStatus.length > 0) {
//           setOrderStatuses(data.orderStatus);
//         }

//         // Store drivers for filter dropdown
//         if (data.drivers && data.drivers.length > 0) {
//           setDrivers(data.drivers);
//         }

//         setRefreshList(false);
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, [
//     activeTab,
//     refreshList,
//     currentBranch,
//     paginationModel.page,
//     paginationModel.pageSize,
//     sortModel,
//     submittedData,
//   ]);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleChangeFilter = (field) => (event, value) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [field]: value || (event && event.target.value) || "",
//     }));
//   };

//   const currentTabConfig = ORDER_STATUSES.find(
//     (tab) => tab.value === activeTab
//   );
//   const handleFilter = createFilterHandler({
//     setLoading,
//     setSubmittedData,
//     setResults: (data) => {
//       // Add unique id for DataGrid (using job_id as the unique identifier)
//       const ordersWithId = data.map((order, index) => ({
//         ...order,
//         id: order.job_id || index,
//       }));
//       setOrders(ordersWithId);
//     },
//     showNotification,
//     handleApiError,
//     httpClient: httpclient,
//     endpoint: resolveOrdersEndpoint(currentTabConfig?.value || "all", isToday),
//     fieldMappings,
//     rangeFields,
//     valueTransformers,
//     refresh,
//   });

//   const onFilterClick = () => {
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     handleFilter(filterData);
//   };

//   const handleFilterToggle = (event) => {
//     setFilterAnchorEl((prev) => (prev ? null : event.currentTarget));
//   };

//   const handleFilterClose = () => {
//     setFilterAnchorEl(null);
//   };

//   const handleRemove = async (field) => {
//     const newFilterData = { ...filterData };
//     const newSubmittedData = { ...submittedData };

//     newFilterData[field] = "";
//     delete newSubmittedData[field];

//     setFilterData(newFilterData);
//     setSubmittedData(newSubmittedData);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));

//     // Manually fetch data after removing filter to ensure proper id assignment
//     setLoading(true);
//     const endpoint = resolveOrdersEndpoint(activeTab, isToday);

//     const apiUrl = buildApiQuery(endpoint, {
//       page: 1,
//       pageSize: paginationModel.pageSize,
//       filters: newSubmittedData,
//       sortModel,
//       fieldMappings,
//       rangeFields,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;

//       if (data.status === 200) {
//         const ordersWithId = data.data.map((order, index) => ({
//           ...order,
//           id: order.job_id || index,
//         }));
//         setOrders(ordersWithId);
//         setRowCount(data.meta?.total || data.count || 0);

//         if (data.orderStatus && data.orderStatus.length > 0) {
//           setOrderStatuses(data.orderStatus);
//         }

//         if (data.drivers && data.drivers.length > 0) {
//           setDrivers(data.drivers);
//         }
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClearFilters = () => {
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleRowClick = (params) => {
//     setSelectedJobId(params.row.job_id);
//     setOrderDetailsOpen(true);
//   };

//   const handleCloseOrderDetails = () => {
//     setOrderDetailsOpen(false);
//     setSelectedJobId(null);
//   };

//   const columns = getColumns();

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <OrderCounts onCardClick={handleTabChange} activeTab={activeTab} isToday={isToday} showAllCard={showAllCard} showWaitingCard={showWaitingCard} />
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12}>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 mb: 2,
//               }}
//             >
//               <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                 Jobs
//               </Typography>
//               <Box
//                 component="img"
//                 src={filterAnchorEl ? FilterBtnUp : FilterBtn}
//                 alt="Filter"
//                 sx={{ cursor: "pointer" }}
//                 onClick={handleFilterToggle}
//               />
//             </Box>
//             {/* <OrderTabs
//               activeTab={activeTab}
//               onTabChange={handleTabChange}
//               filterOpen={filterOpen}
//               filterIcon={filterOpen ? FilterBtnUp : FilterBtn}
//               onFilterClick={() => setFilterOpen(!filterOpen)}
//             /> */}
//           </Grid>
//           <Filter
//             filterOpen={Boolean(filterAnchorEl)}
//             filterAnchorEl={filterAnchorEl}
//             onCloseFilter={handleFilterClose}
//             filterData={filterData}
//             handleChangeFilter={handleChangeFilter}
//             handleFilter={() => {
//               onFilterClick();
//               handleFilterClose();
//             }}
//             handleClearFilters={handleClearFilters}
//             handleRemove={handleRemove}
//             submittedData={submittedData}
//             orderStatuses={orderStatuses}
//             drivers={drivers}
//           />
//         </Grid>

//         <DataGrid
//           rows={orders || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           onRowClick={handleRowClick}
//           initialState={{
//             pagination: { paginationModel: { pageSize: 20 } },
//           }}
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           disableColumnMenu
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//             "& .MuiDataGrid-columnHeader": {
//               backgroundColor: "#d6d6d6ff !important",
//               color: "#fff !important",
//             },
//             "& .MuiDataGrid-columnHeaderTitle": {
//               fontWeight: 700,
//               color: "#242424ff !important",
//             },
//             "& .MuiDataGrid-columnSeparator": {
//               color: "rgba(177, 177, 177, 1)",
//             },
//             "& .MuiDataGrid-row": {
//               cursor: "pointer",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel}
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />
//       </Box>

//       {/* Order Details Modal */}
//       {orderDetailsOpen && (
//   <OrderDetailsModal
//     open={orderDetailsOpen}
//     onClose={handleCloseOrderDetails}
//     jobId={selectedJobId}
//     allDrivers={drivers}
//     onRefresh={() => {
//       setRefreshList(true);
//     }}
//   />
// )}
//     </Box>
//   );
// }
// *************************************************************************************

// import { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { DataGrid } from "@mui/x-data-grid";
// import { Box, Typography, Grid } from "@mui/material";

// import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
// import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
// import { useNotification } from "../../../../Hooks/useNotification";
// import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
// import httpclient from "../../../../Utils";
// import { createFilterHandler } from "../../../../Utils/FilterUtils";
// import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
// import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
// import { useBranch } from "../../../../Hooks/useBranch";
// import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

// import Filter from "./Filter";
// import { ORDER_STATUSES } from "./constants";
// // import OrderTabs from "./OrderTabs";

// import { getColumns } from "./columns";
// import OrderDetailsModal from "./OrderDetailsModal";
// import OrderCounts from "./OrderCounts";

// const INITIAL_FILTER_STATE = {
//   invoice_number: "",
//   jobNo: "",
//   customer: "",
//   status: "",
//    invoiceDateStart: null,
//   invoiceDateEnd: null,
//   // orderDateStart: "",
//   // orderDateEnd: "",
//   deliveryDateStart: "",
//   deliveryDateEnd: "",
//   bay: "",
//   driver_id: "",
// };

// const fieldMappings = {
//   jobNo: ["job_id", "$eq"],
//   customer: ["customer", "$eq"],
//   status: ["delivery_status", "$eq"],
//   bay: ["bin_bay", "$contains"],
//   driver_id: ["driver_id", "$eq"],
//   invoice_number: ["invoice_number", "$eq"],
// };

// const rangeFields = {
//   orderDate: {
//     apiField: "order_date",
//     minField: "orderDateStart",
//     maxField: "orderDateEnd",
//   },
//   deliveryDate: {
//     apiField: "delivery_date",
//     minField: "deliveryDateStart",
//     maxField: "deliveryDateEnd",
//   },
//    invoiceDate: {  
//     apiField: "invoice_date",
//     minField: "invoiceDateStart",
//     maxField: "invoiceDateEnd",
//   },
// };

// const valueTransformers = {
//   // Add any value transformations if needed
// };

// const resolveOrdersEndpoint = (tabValue, isToday) => {
//   const currentTab = ORDER_STATUSES.find((tab) => tab.value === tabValue);
//   const baseEndpoint = currentTab?.endpoint || "delivery/orders/all";

//   if (!isToday) {
//     return baseEndpoint;
//   }

//   const normalized = baseEndpoint.replace(/^\/?delivery\/orders\/?/, "");
//   return normalized
//     ? `/delivery/today-orders/${normalized}`
//     : "/delivery/today-orders/all";
// };

// export default function Orders() {
//   const location = useLocation();
//   const isToday = location.pathname === "/delivery/orders/today";
  
//   // Developer mode: Read query parameters to show hidden cards
//   const searchParams = new URLSearchParams(location.search);
//   const showAllCard = searchParams.get("all") === "true";
//   const showWaitingCard = searchParams.get("waiting") === "true";
  
//   const [orders, setOrders] = useState([]);
//   const [orderStatuses, setOrderStatuses] = useState([]);
//   const [drivers, setDrivers] = useState([]);
//   const [activeTab, setActiveTab] = useState("delivered");
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);
//   const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
//   const [submittedData, setSubmittedData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [rowCount, setRowCount] = useState(0);
//   const [sortModel, setSortModel] = useState([]);
//   const [refreshList, setRefreshList] = useState(false);
//   const [orderDetailsOpen, setOrderDetailsOpen] = useState(false);
//   const [selectedJobId, setSelectedJobId] = useState(null);

//   const { currentBranch } = useBranch();
//   const showNotification = useNotification();
//   const handleApiError = useApiErrorHandler();
//   const { getTokenRefreshed: refresh } = useTokenRefresh();

//   // Reset all state when navigating between All Jobs and Today Jobs
//   useEffect(() => {
//     setOrders([]);
//     setActiveTab("delivered");
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel({ page: 0, pageSize: 20 });
//     setSortModel([]);
//     setFilterAnchorEl(null);
//     setRefreshList(true);
//   }, [location.pathname]);

//   // Handle modal re-opening from navigation state (when returning from TrackOrder)
//   useEffect(() => {
//     if (location.state?.reopenModal && location.state?.jobId) {
//       setSelectedJobId(location.state.jobId);
//       setOrderDetailsOpen(true);

//       // Clear the state to prevent re-opening on refresh
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state]);

//   const fetchOrders = async () => {
//     setLoading(true);

//     const endpoint = resolveOrdersEndpoint(activeTab, isToday);

//     const apiUrl = buildApiQuery(endpoint, {
//       page: paginationModel.page + 1,
//       pageSize: paginationModel.pageSize,
//       filters: submittedData,
//       sortModel,
//       fieldMappings,
//       rangeFields,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;

//       if (data.status === 200) {
//         // Add unique id for DataGrid (using job_id as the unique identifier)
//         const ordersWithId = data.data.map((order, index) => ({
//           ...order,
//           id: order.job_id || index,
//         }));
//         setOrders(ordersWithId);
//         setRowCount(data.meta?.total || data.count || 0);

//         // Store order statuses for filter dropdown
//         if (data.orderStatus && data.orderStatus.length > 0) {
//           setOrderStatuses(data.orderStatus);
//         }

//         // Store drivers for filter dropdown
//         if (data.drivers && data.drivers.length > 0) {
//           setDrivers(data.drivers);
//         }

//         setRefreshList(false);
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, [
//     activeTab,
//     refreshList,
//     currentBranch,
//     paginationModel.page,
//     paginationModel.pageSize,
//     sortModel,
//     submittedData,
//   ]);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleChangeFilter = (field) => (event, value) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [field]: value || (event && event.target.value) || "",
//     }));
//   };

//   const currentTabConfig = ORDER_STATUSES.find(
//     (tab) => tab.value === activeTab
//   );
//   const handleFilter = createFilterHandler({
//     setLoading,
//     setSubmittedData,
//     setResults: (data) => {
//       // Add unique id for DataGrid (using job_id as the unique identifier)
//       const ordersWithId = data.map((order, index) => ({
//         ...order,
//         id: order.job_id || index,
//       }));
//       setOrders(ordersWithId);
//     },
//     showNotification,
//     handleApiError,
//     httpClient: httpclient,
//     endpoint: resolveOrdersEndpoint(currentTabConfig?.value || "all", isToday),
//     fieldMappings,
//     rangeFields,
//     valueTransformers,
//     refresh,
//   });

//   const onFilterClick = () => {
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//     handleFilter(filterData);
//   };

//   const handleFilterToggle = (event) => {
//     setFilterAnchorEl((prev) => (prev ? null : event.currentTarget));
//   };

//   const handleFilterClose = () => {
//     setFilterAnchorEl(null);
//   };

//   const handleRemove = async (field) => {
//     const newFilterData = { ...filterData };
//     const newSubmittedData = { ...submittedData };

//     newFilterData[field] = "";
//     delete newSubmittedData[field];

//     setFilterData(newFilterData);
//     setSubmittedData(newSubmittedData);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));

//     // Manually fetch data after removing filter to ensure proper id assignment
//     setLoading(true);
//     const endpoint = resolveOrdersEndpoint(activeTab, isToday);

//     const apiUrl = buildApiQuery(endpoint, {
//       page: 1,
//       pageSize: paginationModel.pageSize,
//       filters: newSubmittedData,
//       sortModel,
//       fieldMappings,
//       rangeFields,
//       valueTransformers,
//     });

//     try {
//       const res = await httpclient.get(apiUrl);
//       const { data } = res;

//       if (data.status === 200) {
//         const ordersWithId = data.data.map((order, index) => ({
//           ...order,
//           id: order.job_id || index,
//         }));
//         setOrders(ordersWithId);
//         setRowCount(data.meta?.total || data.count || 0);

//         if (data.orderStatus && data.orderStatus.length > 0) {
//           setOrderStatuses(data.orderStatus);
//         }

//         if (data.drivers && data.drivers.length > 0) {
//           setDrivers(data.drivers);
//         }
//       } else {
//         showNotification("error", data.message);
//       }
//     } catch (error) {
//       if (error.response?.status === 401) {
//         refresh();
//       } else {
//         handleApiError(error);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClearFilters = () => {
//     setFilterData(INITIAL_FILTER_STATE);
//     setSubmittedData({});
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleSortModelChange = (newSortModel) => {
//     setSortModel(newSortModel);
//     setPaginationModel((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleRowClick = (params) => {
//     setSelectedJobId(params.row.job_id);
//     setOrderDetailsOpen(true);
//   };

//   const handleCloseOrderDetails = () => {
//     setOrderDetailsOpen(false);
//     setSelectedJobId(null);
//   };

//   const columns = getColumns();

//   return (
//     <Box sx={{ width: "100%", padding: 2 }}>
//       <OrderCounts onCardClick={handleTabChange} activeTab={activeTab} isToday={isToday} showAllCard={showAllCard} showWaitingCard={showWaitingCard} />
//       <Box
//         sx={{
//           position: "relative",
//           width: "100%",
//           backgroundColor: "#fff",
//           padding: "16px",
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12}>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 mb: 2,
//               }}
//             >
//               <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                 Jobs
//               </Typography>
//               <Box
//                 component="img"
//                 src={filterAnchorEl ? FilterBtnUp : FilterBtn}
//                 alt="Filter"
//                 sx={{ cursor: "pointer" }}
//                 onClick={handleFilterToggle}
//               />
//             </Box>
//             {/* <OrderTabs
//               activeTab={activeTab}
//               onTabChange={handleTabChange}
//               filterOpen={filterOpen}
//               filterIcon={filterOpen ? FilterBtnUp : FilterBtn}
//               onFilterClick={() => setFilterOpen(!filterOpen)}
//             /> */}
//           </Grid>
//           <Filter
//             filterOpen={Boolean(filterAnchorEl)}
//             filterAnchorEl={filterAnchorEl}
//             onCloseFilter={handleFilterClose}
//             filterData={filterData}
//             handleChangeFilter={handleChangeFilter}
//             handleFilter={() => {
//               onFilterClick();
//               handleFilterClose();
//             }}
//             handleClearFilters={handleClearFilters}
//             handleRemove={handleRemove}
//             submittedData={submittedData}
//             orderStatuses={orderStatuses}
//             drivers={drivers}
//           />
//         </Grid>

//         <DataGrid
//           rows={orders || []}
//           columns={columns}
//           autoHeight
//           disableRowSelectionOnClick
//           onRowClick={handleRowClick}
//           initialState={{
//             pagination: { paginationModel: { pageSize: 20 } },
//           }}
//           loading={loading}
//           slots={{
//             loadingOverlay: CustomLoadingOverlay,
//           }}
//           disableColumnMenu
//           sx={{
//             "& .MuiDataGrid-cell": {
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#48505E",
//             },
//             "& .MuiDataGrid-columnHeader": {
//               backgroundColor: "#d6d6d6ff !important",
//               color: "#fff !important",
//             },
//             "& .MuiDataGrid-columnHeaderTitle": {
//               fontWeight: 700,
//               color: "#242424ff !important",
//             },
//             "& .MuiDataGrid-columnSeparator": {
//               color: "rgba(177, 177, 177, 1)",
//             },
//             "& .MuiDataGrid-row": {
//               cursor: "pointer",
//             },
//           }}
//           paginationMode="server"
//           sortingMode="server"
//           onSortModelChange={handleSortModelChange}
//           sortModel={sortModel}
//           rowCount={rowCount}
//           paginationModel={paginationModel}
//           onPaginationModelChange={setPaginationModel}
//           pageSizeOptions={[20, 50, 100]}
//         />
//       </Box>

//       {/* Order Details Modal */}
//       {orderDetailsOpen && (
//   <OrderDetailsModal
//     open={orderDetailsOpen}
//     onClose={handleCloseOrderDetails}
//     jobId={selectedJobId}
//     allDrivers={drivers}
//     onRefresh={() => {
//       setRefreshList(true);
//     }}
//   />
// )}
//     </Box>
//   );
// }
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography, Grid } from "@mui/material";

import FilterBtn from "../../../../Assets/Icons/btn-filters.png";
import FilterBtnUp from "../../../../Assets/Icons/btn-filters-up.png";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import httpclient from "../../../../Utils";
import { createFilterHandler } from "../../../../Utils/FilterUtils";
import CustomLoadingOverlay from "../../../../Components/CustomLoadingOverlay";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";
import { useBranch } from "../../../../Hooks/useBranch";
import { buildApiQuery } from "../../../../Utils/apiQueryBuilder";

import Filter from "./Filter";
// import OrderTabs from "./OrderTabs";

import { getColumns } from "./columns";
import OrderDetailsModal from "./OrderDetailsModal";
import OrderCounts from "./OrderCounts";
import DriversPanel from "./DriversPanel";
import DriverJobsTable from "./DriverJobsTable";

import {
  INITIAL_FILTER_STATE,
  fieldMappings,
  rangeFields,
  valueTransformers,
  resolveOrdersEndpoint,
} from "./orderFilterConfig";

export default function Orders() {
  const location = useLocation();
  const isToday = location.pathname === "/delivery/orders/today";

  const [orders, setOrders] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [allowAllInvoiceTab, setAllowAllInvoiceTab] = useState(false);
  const [driverStatuswiseCounts, setDriverStatuswiseCounts] = useState(null);
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "overview"
  );
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
  const [submittedData, setSubmittedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [sortModel, setSortModel] = useState([]);
  const [refreshList, setRefreshList] = useState(false);
  const [orderDetailsOpen, setOrderDetailsOpen] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [selectedInvoiceNumbers, setSelectedInvoiceNumbers] = useState("");

  const { currentBranch } = useBranch();
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  // Reset all state when navigating between All Jobs and Today Jobs
  useEffect(() => {
    setOrders([]);
    setActiveTab(location.state?.activeTab || "overview");
    setFilterData(INITIAL_FILTER_STATE);
    setSubmittedData({});
    setPaginationModel({ page: 0, pageSize: 20 });
    setSortModel([]);
    setFilterAnchorEl(null);
    setRefreshList(true);

    // Clear the nav state so a later in-page tab click (or back navigation)
    // doesn't get overridden by the stale dashboard-selected tab
    if (location.state?.activeTab) {
      window.history.replaceState({}, document.title);
    }
  }, [location.pathname, location.state?.activeTab]);

  // Handle modal re-opening from navigation state (when returning from TrackOrder)
  useEffect(() => {
    if (location.state?.reopenModal && location.state?.jobId) {
      setSelectedJobId(location.state.jobId);
      setOrderDetailsOpen(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const fetchOrders = async () => {
    setLoading(true);

    const endpoint = resolveOrdersEndpoint(activeTab, isToday);

    const apiUrl = buildApiQuery(endpoint, {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      filters: submittedData,
      sortModel,
      fieldMappings,
      rangeFields,
      valueTransformers,
    });

    try {
      const res = await httpclient.get(apiUrl);
      const { data } = res;

      if (data.status === 200) {
        const ordersWithId = data.data.map((order, index) => ({
          ...order,
          id: order.job_id || index,
        }));
        setOrders(ordersWithId);
        setRowCount(data.meta?.total || data.count || 0);

        if (data.orderStatus && data.orderStatus.length > 0) {
          setOrderStatuses(data.orderStatus);
        }

        if (data.drivers && data.drivers.length > 0) {
          setDrivers(data.drivers);
        }

        setAllowAllInvoiceTab(data.allow_all_invoice_tab_enabled === 1);

        setRefreshList(false);
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  // The driver-first expandable view only applies outside "All" and
  // "Waiting for Delivery" (inQueue) - those two keep the plain
  // table. Each expanded driver there owns its own DriverJobsTable
  // instance/fetch, so this shared table is skipped entirely in that mode.
  const isDriverExpandableTab = !["all", "inQueue"].includes(activeTab);

  useEffect(() => {
    if (isDriverExpandableTab) {
      return;
    }
    fetchOrders();
  }, [
    activeTab,
    refreshList,
    currentBranch,
    paginationModel.page,
    paginationModel.pageSize,
    sortModel,
    submittedData,
    isDriverExpandableTab,
  ]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    setFilterData((prev) => ({ ...prev, driver_id: "" }));
    setSubmittedData((prev) => {
      const { driver_id, ...rest } = prev;
      return rest;
    });
  };

  const handleChangeFilter = (field) => (event, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value || (event && event.target.value) || "",
    }));
  };

  const handleFilter = createFilterHandler({
    setLoading,
    setSubmittedData,
    setResults: (data) => {
      const ordersWithId = data.map((order, index) => ({
        ...order,
        id: order.job_id || index,
      }));
      setOrders(ordersWithId);
    },
    showNotification,
    handleApiError,
    httpClient: httpclient,
    endpoint: resolveOrdersEndpoint(activeTab || "all", isToday),
    fieldMappings,
    rangeFields,
    valueTransformers,
    refresh,
  });

  const onFilterClick = () => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    handleFilter(filterData);
  };

  const handleFilterToggle = (event) => {
    setFilterAnchorEl((prev) => (prev ? null : event.currentTarget));
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleRemove = async (field) => {
    const newFilterData = { ...filterData };
    const newSubmittedData = { ...submittedData };

    newFilterData[field] = "";
    delete newSubmittedData[field];

    setFilterData(newFilterData);
    setSubmittedData(newSubmittedData);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    setLoading(true);
    const endpoint = resolveOrdersEndpoint(activeTab, isToday);

    const apiUrl = buildApiQuery(endpoint, {
      page: 1,
      pageSize: paginationModel.pageSize,
      filters: newSubmittedData,
      sortModel,
      fieldMappings,
      rangeFields,
      valueTransformers,
    });

    try {
      const res = await httpclient.get(apiUrl);
      const { data } = res;

      if (data.status === 200) {
        const ordersWithId = data.data.map((order, index) => ({
          ...order,
          id: order.job_id || index,
        }));
        setOrders(ordersWithId);
        setRowCount(data.meta?.total || data.count || 0);

        if (data.orderStatus && data.orderStatus.length > 0) {
          setOrderStatuses(data.orderStatus);
        }

        if (data.drivers && data.drivers.length > 0) {
          setDrivers(data.drivers);
        }
      } else {
        showNotification("error", data.message);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilters = () => {
    setFilterData(INITIAL_FILTER_STATE);
    setSubmittedData({});
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  };

  // ✅ UPDATED: Handle row click - fetch grouped invoices
  const handleRowClick = async (params) => {
    const row = params.row;

    // console.log("🔍 Row clicked:", row);
    // console.log("📋 Invoice number from row:", row.invoice_number);
    
    // Store the job ID
    setSelectedJobId(row.job_id);
    
    // If the row has a related_job_list, use it directly
    if (row.related_job_list && row.related_job_list.length > 0) {
      const invoiceNumbers = row.related_job_list.join(',');
      // console.log("📋 Using related_job_list:", invoiceNumbers);
      setSelectedInvoiceNumbers(invoiceNumbers);
      setOrderDetailsOpen(true);
      return;
    }
    
    // Otherwise, use the single invoice number from the row
    // The OrderDetailsModal will fetch grouped invoices using this
    const invoiceNumber = row.invoice_number;
    // console.log("📋 Passing single invoice number to modal:", invoiceNumber);
    
    if (invoiceNumber) {
      setSelectedInvoiceNumbers(invoiceNumber);
      setOrderDetailsOpen(true);
    } else {
      showNotification("error", "No invoice number found for this order");
    }
  };

  const handleCloseOrderDetails = () => {
    setOrderDetailsOpen(false);
    setSelectedJobId(null);
    setSelectedInvoiceNumbers("");
  };

  const columns = getColumns(activeTab);

  const renderJobsSection = () => (
    <>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Jobs
            </Typography>
            <Box
              component="img"
              src={filterAnchorEl ? FilterBtnUp : FilterBtn}
              alt="Filter"
              sx={{ cursor: "pointer" }}
              onClick={handleFilterToggle}
            />
          </Box>
        </Grid>
        <Filter
          filterOpen={Boolean(filterAnchorEl)}
          filterAnchorEl={filterAnchorEl}
          onCloseFilter={handleFilterClose}
          filterData={filterData}
          handleChangeFilter={handleChangeFilter}
          handleFilter={() => {
            onFilterClick();
            handleFilterClose();
          }}
          handleClearFilters={handleClearFilters}
          handleRemove={handleRemove}
          submittedData={submittedData}
          drivers={drivers}
          activeTab={activeTab}
        />
      </Grid>

      <DataGrid
        rows={orders || []}
        columns={columns}
        autoHeight
        disableRowSelectionOnClick
        onRowClick={handleRowClick}
        initialState={{
          pagination: { paginationModel: { pageSize: 20 } },
        }}
        loading={loading}
        slots={{
          loadingOverlay: CustomLoadingOverlay,
        }}
        disableColumnMenu
        sx={{
          backgroundColor: "#fff",
          "& .MuiDataGrid-cell": {
            fontSize: "14px",
            fontWeight: 500,
            color: "#48505E",
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#d6d6d6ff !important",
            color: "#fff !important",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
            color: "#242424ff !important",
          },
          "& .MuiDataGrid-columnSeparator": {
            color: "rgba(177, 177, 177, 1)",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          },
        }}
        paginationMode="server"
        sortingMode="server"
        onSortModelChange={handleSortModelChange}
        sortModel={sortModel}
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[20, 50, 100]}
      />
    </>
  );

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <OrderCounts
        onCardClick={handleTabChange}
        activeTab={activeTab}
        isToday={isToday}
        showAllCard={allowAllInvoiceTab}
        showWaitingCard={allowAllInvoiceTab}
        externalCounts={driverStatuswiseCounts}
        restrictBaselineToAllAndWaiting
      />
      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "16px",
          borderRadius: "8px",
        }}
      >
        {isDriverExpandableTab ? (
          <DriversPanel
            activeTab={activeTab}
            isToday={isToday}
            onAllowAllInvoiceTabChange={setAllowAllInvoiceTab}
            onStatuswiseCountChange={setDriverStatuswiseCounts}
            renderExpandedContent={(driver, period, fetchDriverJobsPage) => (
              <DriverJobsTable
                driver={driver}
                activeTab={activeTab}
                period={period}
                onPageChange={fetchDriverJobsPage}
              />
            )}
          />
        ) : (
          renderJobsSection()
        )}
      </Box>

      {/* Order Details Modal */}
      {orderDetailsOpen && (
        <OrderDetailsModal
          open={orderDetailsOpen}
          onClose={handleCloseOrderDetails}
          invoiceNumbers={selectedInvoiceNumbers}
          jobId={selectedJobId}
          allDrivers={drivers}
          onRefresh={() => {
            setRefreshList(true);
          }}
        />
      )}
    </Box>
  );
}